import { Tooltip as MSTooltip, type TooltipProps } from '@fluentui/react-components'
import { useMediaQuery } from 'react-responsive'
export const Tooltip = (props: TooltipProps) => {
  const hasHover = useMediaQuery({ query: '(hover: hover) and (pointer: fine)' })
  return <MSTooltip {...props} visible={hasHover ? props.visible : false} />
}
